export function animatedSlider() {
    let pauseOnHover = false;
    if ($('.animated-slider').hasClass("testimonials-list")) {
        pauseOnHover = true;
    }
    $('.animated-slider').infiniteslide({
        pauseonhover: pauseOnHover,
        speed: 30
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animatedSlider.js